import { render, staticRenderFns } from "./TipBox.vue?vue&type=template&id=7350e1ba&scoped=true&"
import script from "./TipBox.vue?vue&type=script&lang=js&"
export * from "./TipBox.vue?vue&type=script&lang=js&"
import style0 from "./TipBox.vue?vue&type=style&index=0&id=7350e1ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7350e1ba",
  null
  
)

export default component.exports